import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'help-cutin',
  templateUrl: './help-cutin.component.html',
  styleUrls: ['../help.content.css']
})
export class HelpCutinComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
